import React from 'react'
import type { CascadeViewMode } from './strategyMapHelpers'
import './CanvasToolbar.css'

interface Props {
  isFullscreen: boolean
  onToggleFullscreen: () => void
  viewMode: CascadeViewMode
  onChangeViewMode: (mode: CascadeViewMode) => void
}

export const CanvasToolbar: React.FC<Props> = ({
  isFullscreen,
  onToggleFullscreen,
  viewMode,
  onChangeViewMode,
}) => {
  const fullscreenLabel = isFullscreen ? 'Exit full screen' : 'Enter full screen'
  const fullscreenIcon = isFullscreen ? '⤢' : '⛶'
  const fullscreenTitle = isFullscreen
    ? 'Exit full screen (Esc)'
    : 'Enter full screen — press Esc to exit'

  const setIfDifferent = (next: CascadeViewMode) => {
    if (next !== viewMode) onChangeViewMode(next)
  }

  return (
    <div className="canvas-toolbar" role="toolbar" aria-label="Canvas toolbar">
      <div className="canvas-toolbar-group" role="group" aria-label="Cascade view mode">
        <button
          type="button"
          className="canvas-toolbar-btn canvas-toolbar-segmented"
          aria-pressed={viewMode === 'filtered'}
          aria-label="Filtered cascade view: show only high-strength inter-perspective links"
          title="Show only high-strength inter-perspective links (Kaplan-Norton cascade)"
          onClick={() => setIfDifferent('filtered')}
        >
          <span className="canvas-toolbar-label">Filtered</span>
        </button>
        <button
          type="button"
          className="canvas-toolbar-btn canvas-toolbar-segmented"
          aria-pressed={viewMode === 'all'}
          aria-label="All-relationships cascade view: show every causal link"
          title="Show every causal link in the strategy map"
          onClick={() => setIfDifferent('all')}
        >
          <span className="canvas-toolbar-label">All</span>
        </button>
      </div>
      <button
        type="button"
        className="canvas-toolbar-btn"
        aria-pressed={isFullscreen}
        aria-label={fullscreenLabel}
        title={fullscreenTitle}
        onClick={onToggleFullscreen}
      >
        <span className="canvas-toolbar-icon" aria-hidden="true">{fullscreenIcon}</span>
        <span className="canvas-toolbar-label">{fullscreenLabel}</span>
      </button>
    </div>
  )
}
